/**
 * UUID v4 for the `X-Request-ID` header. Mirrors the platform generator
 * (saas-auth / saas_login). Prefers `crypto.randomUUID` and falls back to a
 * Math.random-seeded template for older runtimes.
 */
export function generateRequestId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
